import {
  ISportUnityCreateProps,
  ISportUnityFilterParams,
  ISportUnityGetParams,
  ISportUnityProps,
  ISportUnitySimpleProps,
  ISportUnityUpdateParams,
} from './types';
import { api } from '../../DefaultService';
import { IPaginationParams } from '../../types';

const ENDPOINT = '/v1/sports/unities';

export const createSportUnityAsync = async (
  data: ISportUnityCreateProps,
): Promise<ISportUnityProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSportUnityAsync = async ({
  id,
  data,
}: ISportUnityUpdateParams): Promise<ISportUnityProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSportUnityAsync = async (
  id: number,
): Promise<ISportUnityProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSportUnityAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getSportUnitiesByLicenseAsync = async ({
  pagination,
  filter,
}: ISportUnityGetParams): Promise<ISportUnitySimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSportUnitiesByLicenseCountAsync = async (
  filter?: ISportUnityFilterParams,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
